import { Mapper } from "../../../../base/utils/mapper";
import { SurfaceFilmResponseModel } from "../../../../domain/models/consult/surface-film-response.model";
import { SurfaceFilmResponseEntity } from "../entities/surface-film-response.entity";

export class SurfaceFilmImplementationRepositoryMapper extends Mapper<SurfaceFilmResponseEntity, SurfaceFilmResponseModel> {
    mapFrom(param: SurfaceFilmResponseEntity): SurfaceFilmResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: SurfaceFilmResponseModel): SurfaceFilmResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}